import { setLocale } from '@hejdoktor/resx-compiler';

import { IBootstrappedData } from './interfaces';

declare let bootstrapped: IBootstrappedData;

setLocale(bootstrapped.CurrentLocale);

export default bootstrapped;
